module.exports = __webpack_public_path__ + "d6b005846c42ff1856dd8f7ccbd57a64.png";